import React from "react";
import { Tag, Space, Button, Switch } from "antd";
import { EditOutlined, KeyOutlined } from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

const getRoleColor = (roleName) => {
  const role = (roleName || "").toLowerCase();
  if (role === "admin") return "#49627a";
  if (role === "all_users") return "#2b751d";
  if (role === "analyst") return "#e29b45";
  if (role === "modeler") return "#bd565d";
  return "default";
};

export default function SkeyecubeUsersTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  onEditUser,
  onChangePassword,
  onToggleStatus,
  isRoleUser,
}) {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "20%",
      sorter: (a, b) =>
        (a.id || "").toString().localeCompare((b.id || "").toString()),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "20%",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
    },
    {
      title: "Groups",
      dataIndex: "groups",
      key: "groups",
      width: "35%",
      render: (groups) => (
        <Space size={[0, 4]} wrap>
          {(groups || []).map((role, idx) => (
            <Tag color={getRoleColor(role)} key={idx}>
              {role}
            </Tag>
          ))}
        </Space>
      ),
    },
    {
      title: "Status",
      dataIndex: "disabled",
      key: "disabled",
      width: "15%",
      render: (disabled, record) => (
        <Switch
          checked={!disabled}
          onChange={() => onToggleStatus(record.name, disabled)}
          disabled={isRoleUser}
          checkedChildren="Active"
          unCheckedChildren="Disabled"
        />
      ),
      sorter: (a, b) => (a.disabled === b.disabled ? 0 : a.disabled ? 1 : -1),
    },
  ];

  if (!isRoleUser) {
    columns.push({
      title: "Actions",
      key: "actions",
      width: "10%",
      render: (_, record) => (
        <Space size="small">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEditUser(record)}
            style={{ color: "#D97A07" }}
            title="Edit User Authorities"
          />
          <Button
            type="text"
            icon={<KeyOutlined />}
            onClick={() => onChangePassword(record)}
            style={{ color: "#e29b45" }}
            title="Change Password"
          />
        </Space>
      ),
    });
  }

  return (
    <DataTable
      rowKey="name"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
